// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__23oyo","inputWrap":"Table_inputWrap__2x_5f","col":"Table_col__1WKgO","bmiTooltip":"Table_bmiTooltip__1622e"};